import { render, staticRenderFns } from "./DnsRecord.vue?vue&type=template&id=3aad966b&scoped=true&"
import script from "./DnsRecord.vue?vue&type=script&lang=js&"
export * from "./DnsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad966b",
  null
  
)

export default component.exports